import { Box } from "@mui/material"
import CustomizedTables from "../../common/Table"
import { deleteEvaluations, getEvaluations } from "../Properties/Properties.service";

const Evaluation = () => {
    const columns: any[] = [
        // { key: "id", label: "ID", minWidth: 90 },
        { key: "firstname", label: "First Name", minWidth: 150 },
        { key: "lastname", label: "lastname", minWidth: 150 },
        { key: "email", label: "Email", minWidth: 130 },
        { key: "number", label: "Mobile Number", minWidth: 150 },
        { key: "postcode", label: "Postal Code", minWidth: 150 },
        { key: "salesValuation", label: "Sales Valuation", minWidth: 150 },
        { key: "lettingsValuation", label: "Letting Valuation", minWidth: 150 },
        { key: "postcode", label: "Postal Code", minWidth: 150 },
        { key: "action", label: "Wants", minWidth: 150 },
        { key: "purpose", label: "Purpose", minWidth: 100 },
    ];
    return (
        <>
            <Box sx={{ paddingY: 6, width: '100%' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><h2>Evaluations List</h2>
                </Box>
                <CustomizedTables
                    columns={columns}
                    listService={getEvaluations}
                    deleteService={deleteEvaluations}
                    isUser={true}
                // editLink={'/editProperty'}
                />
            </Box>
        </>
    )
}

export default Evaluation;